// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DTADocumentContent } from './dta-document-content';
import {
    DTADocumentContentFromJSON,
    DTADocumentContentFromJSONTyped,
    DTADocumentContentToJSON,
    DTADocumentContentToJSONTyped,
} from './dta-document-content';

/**
 * 
 * @export
 * @interface UpdateDtaRequest
 */
export interface UpdateDtaRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateDtaRequest
     */
    data_stream_id?: string;
    /**
     * 
     * @type {DTADocumentContent}
     * @memberof UpdateDtaRequest
     */
    document_content?: DTADocumentContent;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateDtaRequest
     */
    domains?: Array<string>;
    /**
     * Re-extract a DRAFT in place: references a source document already uploaded to S3 via presigned URL. When provided, the DRAFT's content is blanked and the extraction pipeline is triggered targeting this DTA version (extraction_status becomes IN_PROGRESS).
     * @type {string}
     * @memberof UpdateDtaRequest
     */
    upload_id?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateDtaRequest
     */
    vendor_name?: string;
}

/**
 * Check if a given object implements the UpdateDtaRequest interface.
 */
export function instanceOfUpdateDtaRequest(value: object): value is UpdateDtaRequest {
    return true;
}

export function UpdateDtaRequestFromJSON(json: any): UpdateDtaRequest {
    return UpdateDtaRequestFromJSONTyped(json, false);
}

export function UpdateDtaRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateDtaRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'data_stream_id': json['data_stream_id'] == null ? undefined : json['data_stream_id'],
        'document_content': json['document_content'] == null ? undefined : DTADocumentContentFromJSON(json['document_content']),
        'domains': json['domains'] == null ? undefined : json['domains'],
        'upload_id': json['upload_id'] == null ? undefined : json['upload_id'],
        'vendor_name': json['vendor_name'] == null ? undefined : json['vendor_name'],
    };
}

export function UpdateDtaRequestToJSON(json: any): UpdateDtaRequest {
    return UpdateDtaRequestToJSONTyped(json, false);
}

export function UpdateDtaRequestToJSONTyped(value?: UpdateDtaRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data_stream_id': value['data_stream_id'],
        'document_content': DTADocumentContentToJSON(value['document_content']),
        'domains': value['domains'],
        'upload_id': value['upload_id'],
        'vendor_name': value['vendor_name'],
    };
}
